import PropTypes from "prop-types";
import { useTheme, Grid, MenuItem, Select, Typography, Button, TextField, Box } from "@mui/material";
import { LLMAPIProvider, getChatProviderFormat, getLLMAPIProviderTitle } from "../../../../utils/constants";

function SelectLLMProvider(props) {
  const { provider_type, set_provider_type, prompt_filter, set_prompt_filter, output_filter, set_output_filter, updateLLMProvider } = props;

  const theme = useTheme();

  const request_format_placeholder =
    '[{"key": "messages"},\n{"key": "*"},\n{\n    "key": "content",\n    "conditions": [\n        {"key": "role", "operator": "eq", "value": "user"}\n    ]\n}]';
  const response_format_placeholder = '[\n    {"key": "choices"},\n    {"key": "*"},\n    {"key": "message"},\n    {"key": "content"}\n]';

  const updateProvider = async (type) => {
    if (type === LLMAPIProvider.CUSTOM) {
      set_prompt_filter("");
      set_output_filter("");
      set_provider_type(type);
    } else {
      const defaultFormatValues = getChatProviderFormat(type);
      await updateLLMProvider(type, defaultFormatValues[0], defaultFormatValues[1]);
    }
  };

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Select
            value={provider_type}
            fullWidth
            sx={{ color: theme.palette.grey.main }}
            onChange={(e) => {
              updateProvider(parseInt(e.target.value));
            }}
          >
            {Object.values(LLMAPIProvider).map((value) => {
              return (
                <MenuItem key={`period_${value}`} value={value} sx={{ color: theme.palette.grey.main }}>
                  {getLLMAPIProviderTitle(value)}
                </MenuItem>
              );
            })}
          </Select>
        </Grid>
        {provider_type === LLMAPIProvider.CUSTOM && (
          <>
            <Grid item xs={12} md={6}>
              <Box display="flex" justifyContent="flex-end" mb={1}>
                <Button
                  variant="contained"
                  color="success"
                  size="ui"
                  loadingPosition="start"
                  onClick={() => {
                    updateLLMProvider(provider_type, prompt_filter, output_filter);
                  }}
                  sx={{ marginBottom: "16px" }}
                >
                  Update
                </Button>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography pb={3}>Prompt Format</Typography>
              <TextField
                variant="outlined"
                fullWidth
                multiline
                maxRows={8}
                minRows={8}
                sx={{ background: "white", borderRadius: "8px" }}
                value={prompt_filter}
                placeholder={request_format_placeholder}
                onChange={(e) => {
                  set_prompt_filter(e.target.value);
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography pb={3}>Output Format</Typography>
              <TextField
                variant="outlined"
                fullWidth
                multiline
                maxRows={8}
                minRows={8}
                sx={{ background: "white", borderRadius: "8px" }}
                value={output_filter}
                placeholder={response_format_placeholder}
                onChange={(e) => {
                  set_output_filter(e.target.value);
                }}
              />
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
}

SelectLLMProvider.propTypes = {
  provider_type: PropTypes.number.isRequired,
  set_provider_type: PropTypes.func.isRequired,
  prompt_filter: PropTypes.string,
  set_prompt_filter: PropTypes.func,
  output_filter: PropTypes.string,
  set_output_filter: PropTypes.func,
  updateLLMProvider: PropTypes.func,
};

export default SelectLLMProvider;
